import React, { type FC } from 'react';

import { Alert } from '@shared/components/bootstrap';

import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useAffiliateCreateFormQuery, useAffiliateCreateMutation } from '@admin/schema';

import { AffiliateForm } from './form';

export const AffiliateCreateForm: FC = () => {
  useTitle('New Affiliate');
  const { data, error } = useAffiliateCreateFormQuery({ client });
  const [execute, { loading: saving }] = useAffiliateCreateMutation({ client });

  if (error) return <Alert style="danger">{error.message}</Alert>;
  if (!data) return <Spinner />;

  return (
    <AffiliateForm
      saving={saving}
      discountOptions={data.affiliateDiscountOptions}
      save={(input, address) => execute({ variables: { input, address } })}
    />
  );
};
